export default "__VITE_ASSET__C5Y_w_gv__"